import React, { ReactNode } from "react";
import { FaArrowLeft, FaSave } from "react-icons/fa";
import "./usuario-form.css";
import "./planner-form-fields.css";
import "./task-form.css";

export type TaskFormTab = "geral" | "agendamento" | "itens";

const TABS: { id: TaskFormTab; label: string; step: string }[] = [
  { id: "geral", label: "Informações Gerais", step: "1" },
  { id: "agendamento", label: "Agendamento", step: "2" },
  { id: "itens", label: "Itens", step: "3" },
];

export interface TaskFormShellProps {
  mode: "add" | "edit";
  taskId?: string;
  activeTab: TaskFormTab;
  onTabChange: (tab: TaskFormTab) => void;
  onCancel: () => void;
  onSave: () => void;
  onBack: () => void;
  saveDisabled?: boolean;
  cancelDisabled?: boolean;
  children: ReactNode;
}

const TaskFormShell = ({
  mode,
  taskId,
  activeTab,
  onTabChange,
  onCancel,
  onSave,
  onBack,
  saveDisabled = false,
  cancelDisabled = false,
  children,
}: TaskFormShellProps) => {
  return (
    <div className="usuario-form task-form">
      <div className="usuario-form__header">
        <div className="usuario-form__header-left">
          <button
            type="button"
            className="usuario-form__back-btn"
            onClick={onBack}
            title="Voltar"
          >
            <FaArrowLeft size={14} />
          </button>
          <div className="usuario-form__header-text">
            <h2 className="usuario-form__title">
              {mode === "edit" ? (
                <>
                  <span className="usuario-form__title-accent">Editar Tarefa</span>
                  {taskId ? (
                    <span className="usuario-form__id-badge">ID {taskId}</span>
                  ) : null}
                </>
              ) : (
                "Cadastro de Tarefa"
              )}
            </h2>
            <p className="usuario-form__subtitle">
              Preencha as informações gerais, agendamento e itens vinculados à
              tarefa.
            </p>
          </div>
        </div>
        <div className="usuario-form__header-actions">
          <button
            type="button"
            className="usuario-form__btn usuario-form__btn--ghost"
            onClick={onCancel}
            disabled={cancelDisabled}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="usuario-form__btn usuario-form__btn--primary"
            onClick={onSave}
            disabled={saveDisabled}
          >
            <FaSave size={14} />
            Salvar Dados
          </button>
        </div>
      </div>

      <div className="usuario-form__tabs" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.id}
            className={`usuario-form__tab ${
              activeTab === tab.id ? "usuario-form__tab--active" : ""
            }`}
            onClick={() => onTabChange(tab.id)}
          >
            <span className="usuario-form__tab-step">{tab.step}</span>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      <div className="usuario-form__body">{children}</div>

      <div className="usuario-form__footer">
        <p className="usuario-form__footer-hint">
          <span className="usuario-form__footer-line" />
          Preencha as abas e salve a tarefa
        </p>
        <div className="usuario-form__footer-actions">
          <button
            type="button"
            className="usuario-form__btn usuario-form__btn--ghost"
            onClick={onCancel}
            disabled={cancelDisabled}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="usuario-form__btn usuario-form__btn--primary"
            onClick={onSave}
            disabled={saveDisabled}
          >
            <FaSave size={14} />
            Salvar Dados
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaskFormShell;
